import React from 'react';
import { XCloseIcon } from '@rsos/assets/icons';
import { AlertsCopyAllButton } from '@rsos/components/capstone/AlertsCopyAllButton';
import { Box, Text } from '@rsos/components/capstone/base';
import { CloseButton } from './DataCards.styles';
import ShareIncidentButton from './ShareIncident/ShareIncidentButton';
import { getAlertHeaderColor, getAlertHeaderText } from './utils';

const DataCardHeader = React.forwardRef(
  (
    {
      onClose,
      emergencyType,
      siteType,
      serviceProviderName,
      alertStatus,
      setIsShareIncidentModalOpen,
      isShareIncidentAvailable,
      subtype,
    },
    ref,
  ) => {
    const headerColor = getAlertHeaderColor(emergencyType, alertStatus);
    return (
      <Box
        horizontal
        justify="space-between"
        pb={2}
        data-name="alert-data-card-header"
        ref={ref}
      >
        <Box>
          <Text color={headerColor} fontWeight="bold" size="normal">
            {getAlertHeaderText(emergencyType, siteType)}
          </Text>
          {subtype && (
            <Text color="secondaryText" size="small">
              {subtype}
            </Text>
          )}
          <Text color="secondaryText" size="small">
            Source: {serviceProviderName}
          </Text>
        </Box>
        <Box horizontal align="center" height="20px">
          {isShareIncidentAvailable && (
            <ShareIncidentButton
              setIsShareIncidentModalOpen={setIsShareIncidentModalOpen}
            />
          )}
          <AlertsCopyAllButton />
          <CloseButton onClick={() => onClose()}>
            <XCloseIcon />
          </CloseButton>
        </Box>
      </Box>
    );
  },
);

export default DataCardHeader;
